<div 
    class="modal fade show" 
    [ngClass]="{'expanded': isExpanded}"
    id="config-modal" 
    tabindex="-1" 
    aria-labelledby="config-modalLabel" 
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id">
                        <h4 class="modal-title mb-0 item-id">Serial numbers</h4>
                    </div>
                    <div class="btns-header ms-auto">
                        <button 
                            class="header-icon close p-0 m-0" 
                            (click)="close()" 
                            aria-label="Close"
                        >
                            <i 
                                class="fas fa-times" 
                                title="Close Popup"
                            ></i>
                        </button>
                        <button 
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="isExpanded = !isExpanded"
                        >
                            <i 
                                class="fas ms-2 me-2" 
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}" 
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-3">
                <div class="row">
                    <div class="col">
                        @if (USER.role === userRoles.iscManager || USER.role === userRoles.IscSupervisor|| USER.role === userRoles.isc) {
<div class="row mb-3">
                            <div class="col-3 field">
                                <label>Model No.<span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="Model Number"
                                    (change)="this.model = $event.value"
                                ></ejs-textbox>
                                @if (validationApplied && !this.model) {
<div class="field-error">Model number is required</div>
}
                            </div>
                            <div class="col-3 field">
                                <label>Serial No.<span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="Serial Number"
                                    (change)="this.srNumber = $event.value"
                                ></ejs-textbox>
                                @if (validationApplied && !this.srNumber) {
<div class="field-error">Serial number is required</div>
}
                            </div>
                            <div class="col-1">
                                <button class="btn btn-sm btn-success" (click)="getSerialNumbers($event)"> Search</button>
                            </div>
                        </div>
}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        @if (gridConfig) {
<div [style.height.px]="gridHeight">
                            <inavista-grid #serviceOrderGrid class="so-popup-grid"
                                [config]="gridConfig"
                                [actionIcons]="actionIcons"
                                (rowSelected)="rowSelected($event)"
                                (actionIconClick)="onActionIconClick($event)" />
                        </div>
}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>